export default {
  title: {
    id: 'outlet_error_page_title',
    defaultMessage: 'Something went wrong',
  },
  description: {
    id: 'outlet_error_page_description',
    defaultMessage: 'Please check your connection and try again.',
  },
  tryAgain: {
    id: 'outlet_error_page_try_again',
    defaultMessage: 'Try again',
  },
}
